import React, { FC } from "react";
import NewLayout from "../../components/new-ui/Layout";
import HeaderImage from "../../components/CaseStudyComponents/HeaderImage";
import Aside from "../../components/CaseStudyComponents/Aside";
import About from "../../components/CaseStudyComponents/About";
import Impact from "../../components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import Signup from "../../components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";
import AchievementCard from "../../components/CaseStudyComponents/AchievementCard";
import QA from "@components/CaseStudyComponents/QA";

const Numberwale: FC = () => {
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/numberwale/up-arrow.png",
            title: <span className="px-20 inline-block case-study-card-new">25% increase in sales</span>,
            count: " ",
            by: " ",
            borderColor: "#ACDAF1",
            boxShadowColor: "#D4ECF8",
            fontColor: "#3B7D9E",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
            customHeight: true,
            customPadding: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/vcare/generation.png",
            title: <span className="px-16 inline-block case-study-card-new">Targeted campaigns to customers</span>,
            count: " ",
            by: " ",
            borderColor: "#C9E6AD",
            boxShadowColor: "#ECF8E1",
            fontColor: "#72A649",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
            customHeight: true,
            customPadding: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/vcare/quality.png",
            title: <span className="case-study-card-new px-20 inline-block">Quality customer service</span>,
            count: " ",
            by: " ",
            borderColor: "#DEBEF3",
            boxShadowColor: "#EFE1F8",
            fontColor: "#9461B5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
            customHeight: true,
            customPadding: true,
        },
    ];

    return (
        <NewLayout
            title="Numberwale - Case Study | Gallabox"
            description="Numberwale increases their sales by nearly 25% with the help of Gallabox."
            canonical="https://gallabox.com/case-study/numberwale"
        >
            <HeaderImage
                imagePath={"https://assets.gallabox.com/gb-home/case-study/numberwale/numberwale-head-img.png"}
                imageText={"Numberwale increases their sales by nearly 25% with the help of Gallabox."}
            />
            <div className="max-w-md  sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
                <div className="flex flex-col sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "Numberwale",
                                },
                                {
                                    title: "Industry",
                                    content: "Telecom",
                                },
                                {
                                    title: "Employees",
                                    content: "1200+",
                                },
                                {
                                    title: "Product used",
                                    content: ["Contact Tags", "Integration", "WhatsApp Broadcast", "Shared Team Inbox"],
                                },
                                {
                                    title: "Automated Chats Per Month",
                                    content: "14.5K +",
                                },
                                {
                                    title: "Website",
                                    link: "www.numberwale.com",
                                    content: "numberwale.com",
                                },
                            ]}
                        />
                    </div>
                    <main className=" max-w-6xl mx-auto basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/numberwale/numberwale-logo.png"}
                            aboutTitle={"Numberwale"}
                            aboutContent={`Numberwale.com is one of the largest 'telecom number' providers that's nothing short of making your communication special.
                            Our attention to offering your desired numbers, competitive prices and a long list of happy clients speak of our services.`}
                        />
                        <QA
                            li={[
                                `<span class="nxt-wave-impact-para">
                                Before using Gallabox, our customer-facing teams such as sales and support used to handle all our customer conversations on their individual WhatsApp numbers. With a high volume of incoming inquiries, we were not able to track our customer conversations, responses and unanswered chats, and send prompt replies. Thus we seeked a WhatsApp API solution that could handle all our conversations with customers under one single roof. We evaluated a lot of WhatsApp API solution providers but Gallabox came across as the best option.
                                </span>`,
                            ]}
                            question={"What were the challenges you had before using Gallabox? "}
                        />
                        <Quote
                            quoteText={
                                "“The Assign feature in Gallabox helps us assign the right chats to the right person. This helps us save time and avoid confusions between our sales and support teams.”"
                            }
                            quoteBy={"- Mamta,"}
                            position={"Director at Numberwale"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <QA
                            li={[
                                `<li class="nxt-wave-impact-para my-4">
                                We have a practice of using Contact Tags regularly as it helps us in labeling contacts based on their business profile.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                The Assign feature in Gallabox is beneficial for our entire team to assign chats either to sales or support teams based on the inquiry. This way, our team members get only the right customer chats to handle.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                We use WhatsApp Broadcast to shoot bulk messages to our target customers. The Analytics module in Gallabox gives us really great insights about how our broadcast campaigns have performed. This, in turn, helps us optimize our future campaigns. For example, if we send a broadcast campaign to 10,000 contacts and only 10-20% have shown interest in the campaign, our team will work on the areas of improvement for the next campaign for better results. This has helped our team scale faster.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                We have started to explore the WhatsApp chatbots and we are looking forward to getting started with bots sooner.
                                </li>`,
                            ]}
                            question={"How is Gallabox helping you? "}
                        />
                        <Quote
                            quoteText={
                                "“We have been using Gallabox for about 1.5 years. The entire Gallabox team is very helpful. The platform is very simple, easy to use and feature-rich.”"
                            }
                            quoteBy={"- Mamta,"}
                            position={"Director at Numberwale"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <Impact
                            impactContent={[
                                `<span class="nxt-wave-impact-para">
                                After adopting the solution provided by Gallabox, we started selling more numbers to our customers. I can say our sales increased by nearly 25%
                                </span>`,
                            ]}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default Numberwale;
